import { Component, Input, AfterViewInit, ViewChild, ElementRef, OnChanges, ChangeDetectorRef } from '@angular/core';

@Component({
  selector: 'app-testo-espandibile',
  templateUrl: './testo-espandibile.component.html',
  styleUrls: ['./testo-espandibile.component.css']
})
export class TestoEspandibileComponent implements AfterViewInit, OnChanges {
  @Input() text: string = '';
  @Input() maxLines: number = 4;
  @ViewChild('textContainer') textContainer!: ElementRef;

  isExpanded: boolean = false;
  needsTruncation: boolean = false;
  lineHeight: number = 27.2; // 16px * 1.7 (line-height)

  constructor(private cdRef: ChangeDetectorRef) { }

  ngAfterViewInit() {
    // Applica subito il troncamento prima di ogni controllo
    this.applyInitialTruncation();
    setTimeout(() => this.checkTruncation(), 100);
  }

  ngOnChanges() {
    // Applica subito il troncamento quando cambia il testo
    this.applyInitialTruncation();
    setTimeout(() => this.checkTruncation(), 100);
  }

  private applyInitialTruncation() {
    if (!this.textContainer?.nativeElement) return;

    const element = this.textContainer.nativeElement;
    element.style.display = '-webkit-box';
    element.style.webkitLineClamp = this.maxLines.toString();
    element.style.webkitBoxOrient = 'vertical';
    element.style.overflow = 'hidden';
    element.style.maxHeight = `${this.lineHeight * this.maxLines}px`;
    element.style.lineHeight = '1.7';
  }

  private checkTruncation() {
    if (!this.textContainer?.nativeElement) return;

    const element = this.textContainer.nativeElement;

    // Salva lo stato attuale
    const currentDisplay = element.style.display;
    const currentMaxHeight = element.style.maxHeight;

    // Reset temporaneo per la misurazione
    element.style.display = 'block';
    element.style.maxHeight = 'none';
    element.style.overflow = 'visible';

    const contentHeight = element.scrollHeight;
    this.needsTruncation = contentHeight > (this.lineHeight * this.maxLines);
    this.cdRef.detectChanges();

    // Ripristina lo stato troncato se necessario
    if (this.needsTruncation && !this.isExpanded) {
      element.style.display = currentDisplay;
      element.style.maxHeight = currentMaxHeight;
      element.style.overflow = 'hidden';
    }
  }

  toggleExpand() {
    this.isExpanded = !this.isExpanded;

    if (!this.textContainer?.nativeElement) return;

    const element = this.textContainer.nativeElement;
    if (this.isExpanded) {
      element.style.display = 'block';
      element.style.webkitLineClamp = 'unset';
      element.style.maxHeight = 'none';
      element.style.overflow = 'visible';
    } else {
      this.applyInitialTruncation();
    }
  }
}